import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="4" x2="4" y2="8" stroke={fill} strokeWidth="2" />
      <line
        y1="-1"
        x2="8"
        y2="-1"
        transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 8 5)"
        stroke={fill}
        strokeWidth="2"
      />
    </svg>
  );
};

export default memo(Icon);
